export const ICEBREAKER_TEMPLATE_IDS = [
  '617f7a508988360e8f598065', // dev
  '611ff60590fe8bd9c8b491af', // prod
];

export const GENERAL_NEWS_FEED_TEMPLATE_IDS = [
  '61827601d4cbee3d64d0b249', // dev
  '615bcd793dc6424021aa46ec', // prod
];
